import React from "react";
import Icon from "@ant-design/icons";
import type { CustomIconComponentProps } from "@ant-design/icons/lib/components/Icon";

const SortingArrowDownSvg = () => (
  <svg width='1em' height='1em' viewBox='0 0 9 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M4.76991 9.04887C4.57465 9.24413 4.25806 9.24413 4.0628 9.04887L0.880821 5.86689C0.685559 5.67162 0.685559 5.35504 0.880821 5.15978C1.07608 4.96452 1.39267 4.96452 1.58793 5.15978L3.91636 7.48821L3.91636 0.835937C3.91636 0.559795 4.14021 0.335937 4.41636 0.335937C4.6925 0.335937 4.91636 0.559795 4.91636 0.835937L4.91636 7.48821L7.24478 5.15978C7.44004 4.96452 7.75663 4.96452 7.95189 5.15978C8.14715 5.35504 8.14715 5.67162 7.95189 5.86689L4.76991 9.04887Z'
      fill='currentColor'
    />
  </svg>
);

export const SortingArrowDownIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={SortingArrowDownSvg} {...props} />
);
